import { IEmployee } from 'models';
import { useFetchEmployeesQuery, useFetchEmployeeQuery, useUpdateEmployeeMutation } from 'store/apis';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

export const useEmployees = () => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data = [], ...rest } = useFetchEmployeesQuery({ orgSlug });

  /**
   * TODO: Make safe employee structure
   */
  const employees = data.map((item: any) => ({
    ...item,
  }));

  return { data: employees, ...rest };
};

type UseEmployeesTableRowsProps = {
  searchKeyword: string;
  setState?: (state: any) => void;
};

export const useEmployee = ({ employeeId: id }: { employeeId: number }) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data = {}, ...rest } = useFetchEmployeeQuery({ orgSlug, id });

  /**
   * TODO: Make safe employee structure
   */
  const employee = {
    ...data,
  };

  return { data: employee, ...rest };
};

export const useEmployeesTableRows = ({ searchKeyword, setState = () => {} }: UseEmployeesTableRowsProps) => {
  const { data: employeeList, ...rest } = useEmployees();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [updateEmployee] = useUpdateEmployeeMutation();

  /**
   * Init employees
   */
  let employees = [...employeeList];

  /**
   * Filter employees by keyword
   */
  const keyword = searchKeyword.trim().toLocaleLowerCase();

  if (keyword.length > 0) {
    employees = employees.filter((item) => {
      if (`${item.id}`.includes(keyword)) {
        return true;
      }

      if (item.name.toLowerCase().includes(keyword)) {
        return true;
      }

      if (item.email.toLowerCase().includes(keyword)) {
        return true;
      }

      if (item.code && item.code.toLowerCase().includes(keyword)) {
        return true;
      }

      if (item.phone.includes(keyword)) {
        return true;
      }

      return false;
    });
  }

  /**
   * Add actions
   */
  const editEmployee = (employee: IEmployee) =>
    setState((prev: any) => ({ ...prev, employeeId: employee.id, visibleEmployeeUpdateDialog: true }));

  const deactivateEmployee = (employee: IEmployee) => {
    const { id, ...rest } = employee;
    updateEmployee({ orgSlug, id, employee: { ...rest, code: null } });
  };

  const userBuildingAssignments = (employee: IEmployee) =>
    setState((prev: any) => ({ ...prev, employeeId: employee.id, visibleUserAssignedBuildingsDialog: true }));

  employees = employees.map((item) => ({
    ...item,
    editEmployee,
    deactivateEmployee,
    userBuildingAssignments,
  }));

  return { data: employees, ...rest };
};
